module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-honda.b7621b10.png";